import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { GestureController, ModalController } from '@ionic/angular';
import { Employee, EmployeeGroupe } from 'src/app/_interfaces/Employee';
import { FeedbackService } from 'src/app/_provider/feedback.service';
import { SaveService } from 'src/app/_provider/save.service';
import { TicketEditService } from 'src/app/_provider/ticket-edit.service';
import { TicketEmployee} from 'src/app/_provider/tickets/ticket.service';
import { WorkerAddingTicketService } from './worker-services/worker-adding-ticket.service';
import { WorkerExistingTicketService } from './worker-services/worker-existing-ticket.service';
import { WorkerTicket } from './worker-services/worker-ticket.interface';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-ticket-detail-workers',
  templateUrl: './ticket-detail-workers.component.html',
  styleUrls: ['./ticket-detail-workers.component.scss', '../../../_pages/new-settings/setting-main.scss'],
})
export class TicketDetailWorkersComponent implements OnInit {
  
  public employeeGroupes: EmployeeGroupe[] = []
  public employees: Employee[] = []
  @ViewChild("search", {static: true}) searchElement: ElementRef
  
  public canScroll: boolean = true

  public workerTicket: WorkerTicket 

  private sub: Subscription

  constructor(
    public ticketEditSrv: TicketEditService,
    private modalCtrl: ModalController,
    private feedback: FeedbackService,
    private workerExistingTicket: WorkerExistingTicketService,
    private workerAddingTicket: WorkerAddingTicketService,
    private gestureCtrl: GestureController,
    private changeDetector: ChangeDetectorRef
  ) {
    this.workerTicket = this.workerAddingTicket.isExisting ? this.workerExistingTicket : this.workerAddingTicket
  }


  public get notActiveGroupes(): EmployeeGroupe[]{
    return this.employeeGroupes.filter(eg => !this.workerTicket.isEmployeeGroupeChecked(eg.id) && !this.workerTicket.isEmployeeGroupObserverChecked(eg.id) && !eg.hidden)
  }

  public get activeGroupes(): EmployeeGroupe[]{
    return this.employeeGroupes.filter(eg => this.workerTicket.isEmployeeGroupeChecked(eg.id))
  }

  public get notActiveEmployees(): Employee[]{
    return this.employees.filter(e => !this.workerTicket.isEmployeeChecked(e.id) && !this.workerTicket.isEmployeeObserverChecked(e.id) && !e.hidden)
  }

  public get activeEmployees(): Employee[]{
    return this.employees.filter(e => this.workerTicket.isEmployeeChecked(e.id))
  }

  public get activeEmployeeObserver(): Employee[]{
    return this.employees.filter(e => this.workerTicket.isEmployeeObserverChecked(e.id))
  }

  public get activeEmployeeGroupObserver(): EmployeeGroupe[]{
    return this.employeeGroupes.filter(e => this.workerTicket.isEmployeeGroupObserverChecked(e.id))
  }

  ngAfterViewInit(){
    this.initDragGesture()
  }

  private initDragGesture(){

    document.querySelectorAll(".active-item").forEach((item: any) => {
      const gesture = this.gestureCtrl.create({
        el: item,
        gestureName: 'employeesAndGroupes',
        threshold: 0,
        onStart: () => {
          item.style.background = `rgba(var(--blueRGB), 0.4)`
          item.classList.add("active")
          this.canScroll = false
          this.changeDetector.detectChanges()
          this.feedback.vibrate()
        },
        onMove: ev => {
          let observerSec = document.querySelector("#observer-sec")
          let observerSecRect = observerSec.getBoundingClientRect()
          let editorSec = document.querySelector("#editor-sec")
          let editorSecRect = editorSec.getBoundingClientRect()

          let elementRect = item.getBoundingClientRect()
          item.style.transform = `translate(${ev.deltaX}px, ${ev.deltaY}px)`  
          
          //Schauen von wo her das Item kommt (Bearbeiter oder Beobachter)
          if((item as any).dataset.isobserver == "false"){
            if(
              ((ev.currentY - observerSecRect.height) < observerSecRect.top && (ev.currentY) > observerSecRect.top ) &&
              elementRect.left <= observerSecRect.right - (observerSecRect.width / 2)  &&
              elementRect.right >= observerSecRect.left + (observerSecRect.width / 2) 
            ) observerSec.classList.add("active")
            else observerSec.classList.remove("active")
          }else{
            if(
              ((ev.currentY - editorSecRect.height) < editorSecRect.top && (ev.currentY) > editorSecRect.top ) &&
              elementRect.left <= editorSecRect.right - (editorSecRect.width / 2)  &&
              elementRect.right >= editorSecRect.left + (editorSecRect.width / 2) 
            ) editorSec.classList.add("active")
            else editorSec.classList.remove("active")
          }
          
          

        },
        onEnd: () => {
          const isGroup: boolean = (item as any).dataset.isgroup == "true"

          this.canScroll = true
          this.changeDetector.detectChanges()
          this.feedback.vibrate()

          if(document.querySelector("#observer-sec.active")){
            //Von Bearbeiter zu Beobachter
            if(isGroup){
              const groupId: number = +(item as any).dataset.groupid
              new Promise(async (resolve, reject) => {
                await this.workerTicket.checkEmployeeGroupe(groupId, false)
                await this.workerTicket.checkEmployeeGroupe(groupId, true)
                resolve(true)
              })
            }else{
              const employeeId: number = +(item as any).dataset.employeeid
              new Promise(async (resolve, reject) => {
                await this.workerTicket.checkEmployee(employeeId, false)
                await this.workerTicket.checkEmployee(employeeId, true)
                resolve(true)
              })
            }
            document.querySelector("#observer-sec").classList.remove("active")
          }else if(document.querySelector("#editor-sec.active")){
            //Von Beochter zu Bearbeiter
            if(isGroup){
              const groupId: number = +(item as any).dataset.groupid
              new Promise(async (resolve, reject) => {
                await this.workerTicket.checkEmployeeGroupe(groupId, true)
                await this.workerTicket.checkEmployeeGroupe(groupId, false)
                resolve(true)
              })
            }else{
              const employeeId: number = +(item as any).dataset.employeeid
              new Promise(async (resolve, reject) => {
                await this.workerTicket.checkEmployee(employeeId, true)
                await this.workerTicket.checkEmployee(employeeId, false)
                resolve(true)
              })
            }
            document.querySelector("#editor-sec").classList.remove("active")
            this.initDragGesture()
          }else{
            //Zurück an den Ausgangsort
            item.style.transition = "transform 0.2s ease-in-out"
            item.style.background = isGroup ? `rgba(var(--blueRGB), 0.1)` : `rgba(var(--blueRGB), 0.2)`
            item.classList.remove("active")
            item.style.transform = `translate(0px, 0px)`
            setTimeout(() => item.style.transition = null, 200);
          }

        }
      }, true)
      gesture.enable(true)
    })
  }

  ngOnInit() {
    this.employeeGroupes = Object.assign([], this.ticketEditSrv.employeeGroupes)
    this.employees = Object.assign([], this.ticketEditSrv.employees)
    this.sub = this.workerTicket.checkedHasChanged.subscribe((event: boolean) => {
      if(!event) return
      this.initDragGesture() 
    }) 
  }

  ngOnDestroy(){
    this.sub.unsubscribe()
  }


  ionViewDidEnter(){
    // setTimeout(() => this.searchElement.nativeElement.focus(), 100);
  }

  public async  searchEmployee(event){
    if(event.key == "Enter"){
      if(this.notActiveGroupes.length == 1 && this.notActiveEmployees.length == 0){
        this.feedback.showInformationToast(`Die Gruppe ${this.notActiveGroupes[0]?.description} zu Bearbeitern hinzugefügt.`)
        this.workerTicket.checkEmployeeGroupe(this.notActiveGroupes[0].id, false)
        event.target.value = ""
      }
      if(this.notActiveGroupes.length == 0 && this.notActiveEmployees.length == 1){
        this.feedback.showInformationToast(`Der Mitarbeiter ${this.notActiveEmployees[0]?.firstName} ${this.notActiveEmployees[0]?.lastName} zu Bearbeitern hinzugefügt.`)
        this.workerTicket.checkEmployee(this.notActiveEmployees[0].id, false)
        event.target.value = ""
      }
    }
    const searchText: string = (event.target.value as string).toLowerCase()
    this.employeeGroupes.forEach(eg => eg.hidden = !eg.description.toLowerCase().includes(searchText))
    this.employees.forEach(e => e.hidden = !e.firstName.toLowerCase().includes(searchText) && !e.lastName.toLowerCase().includes(searchText))
  }

  public async closeModal(){
    await this.feedback.hideKeyboardOnIOS()
    await this.modalCtrl.dismiss()
  }

}
